<template>
  <div class="branding-group-layout">
    <div class="only-logo" v-if="SingleLogo">
      <img :src="GetSingleLogoPath" id="logoImg" alt="logoImg"/>
    </div>
    <div v-else>
      <BrandingGroupItem :isPrimary="true" :useGrid="false" :underwriterLogo="PrimaryLogo" v-if="HasPrimaryLogo"></BrandingGroupItem>
      <div class="underwriter-container" v-if="ShowSecondaryLogos">
        <BrandingGroupLayoutRow v-for="(row, index) in SecondaryLogoRows" :useGridLayout="UseGridLayout" :key="index" :underwriterLogos="row"></BrandingGroupLayoutRow>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import BrandingGroupItem from '@/components/common/CorporateBranding/BrandingGroupItem';
import BrandingGroupLayoutRow from '@/components/common/CorporateBranding/BrandingElementsLayout/BrandingGroupLayout/BrandingGroupLayoutRow';
import { useCorporateBranding } from '@/composables';

// Define component options
defineOptions({
  name: 'branding-group-layout'
});

// Define props
const props = defineProps({
  columnCount: {
    type: Number,
    default: 3,
    required: false,
  },
});

// Composables
const { hasBrandingLogo, getBrandingLogos } = useCorporateBranding();

// Methods
const PlaceHolderUnderwriter = () => {
  return {
    BrandingGroupItem: null,
    FullName: "",
    Name: null,
    Order: 0,
    PresId: 0,
    SuffixName: null,
    Type: null,
    UnderwriterId: 0,
  };
};

// Computed properties
const SingleLogo = computed(() => {
  if (getBrandingLogos.value.length == 1 && getBrandingLogos.value[0].BrandingGroupItem.LogoPath) {
    return true;
  }
  return false;
});

const SecondaryLogos = computed(() => {
  return getBrandingLogos.value.filter(l => l.BrandingGroupItem.IsPrimary == false);
});

const UseGridLayout = computed(() => {
  const isAllLogos = SecondaryLogos.value.findIndex(l => !l.BrandingGroupItem.LogoPath) === -1;
  return isAllLogos;
});

const SecondaryLogoRows = computed(() => {
  const rowArray = [];
  for (let i = 0; i < SecondaryLogos.value.length; i+= props.columnCount) {
    const endIndex = i + props.columnCount >  SecondaryLogos.value.length ? SecondaryLogos.value.length : i + props.columnCount;
    let row = SecondaryLogos.value.slice(i, endIndex);
    let rowCnt = row.length;
    if (UseGridLayout.value) {
      while (rowCnt < props.columnCount) {
        row.push(PlaceHolderUnderwriter())
        rowCnt++;
      }
    }
    rowArray.push(row);
  }
  return rowArray;
});

const ShowSecondaryLogos = computed(() => {
  return SecondaryLogos.value.length > 0;
});

const HasPrimaryLogo = computed(() => {
  return getBrandingLogos.value.find(l => l.BrandingGroupItem.IsPrimary) != null;
});

const PrimaryLogo = computed(() => {
  return getBrandingLogos.value.find(l => l.BrandingGroupItem.IsPrimary);
});

const GetSingleLogoPath = computed(() => {
  return getBrandingLogos.value[0].BrandingGroupItem.LogoPath;
});
</script>

<style lang="stylus" scoped>
.branding-group-layout {

  .only-logo {
    height: 400px;
    width: 100%;
    position: relative;

    img {
      max-height: 100%;
      max-width: 100%;
      width: 100%;
      height: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      object-fit: unset;
    }
  }
}
</style>
